import { render } from "./PromotionData.vue?vue&type=template&id=1d150bb3&scoped=true"
import script from "./PromotionData.vue?vue&type=script&lang=js"
export * from "./PromotionData.vue?vue&type=script&lang=js"

import "./PromotionData.vue?vue&type=style&index=0&id=1d150bb3&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d150bb3"]])

export default __exports__